import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';
import ChevronRight from '../../assets/icons/chevron-right.svg';
import IPhone12StackWithAppOpen from '../../assets/images/iPhone12-stack-with-app-open.png';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { isDesktop } from '../../utils/ScreenSizes';

interface IProps {
  header: string;
  actionButtons: React.Component;
  t: (key: string) => string;
}

enum platforms {
  desktop = 'desktop',
  mobile = 'mobile',
}

const themeStyleMapper = {
  [platforms.mobile]: StyleSheet.create({
    bottomContainer: {
      backgroundColor: Theme.GREY_DARK,
      alignItems: 'center',
      padding: defaultScale(15),
    },
    heading: {
      ...Theme.textStyle.heading,
      color: Theme.WHITE,
      marginVertical: defaultScale(20),
    },
    heading2: {
      ...Theme.textStyle.heading2,
      color: Theme.WHITE,
      marginBottom: defaultScale(20),
    },
    bodyCopy: {
      ...Theme.textStyle.bodyCopyReg,
      color: Theme.WHITE,
    },
    chevronTextContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: defaultScale(5),
    },
    bottomTextContainer: {
      padding: defaultScale(10),
      marginBottom: defaultScale(10),
    },
  }),
  [platforms.desktop]: StyleSheet.create({
    bottomContainer: {
      backgroundColor: Theme.WHITE,
      alignItems: 'center',
      paddingTop: defaultScale(15),
    },
    heading: {
      ...Theme.textStyle.heading,
      marginBottom: defaultScale(20),
    },
    heading2: {
      ...Theme.textStyle.heading2,
      marginBottom: defaultScale(20),
    },
    bodyCopy: {
      ...Theme.textStyle.bodyCopyReg,
    },
    chevronTextContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: defaultScale(5),
    },
    bottomTextContainer: {
      padding: defaultScale(10),
      marginBottom: defaultScale(10),
    },
  }),
};

class InstallApp extends PureComponent<IProps> {

  public render() {
    const {
      t, actionButtons, header,
    } = this.props;

    const theme = isDesktop() ? themeStyleMapper[platforms.desktop] : themeStyleMapper[platforms.mobile];

    return (
      <View style={theme.bottomContainer}>
        <Text style={theme.heading}>{header}</Text>
        <Image source={IPhone12StackWithAppOpen} resizeMode='contain'
               style={{ width: '100%', height: defaultScale(200) }} />
        <View>
          <View style={theme.bottomTextContainer}>
            <Text style={theme.heading2}>{t('getAppReasonHeading')}</Text>
            <View style={theme.chevronTextContainer}>
              <ChevronRight style={{ marginRight: defaultScale(10) }} />
              <Text style={theme.bodyCopy}>{t('appReason1')}</Text>
            </View>
            <View style={theme.chevronTextContainer}>
              <ChevronRight style={{ marginRight: defaultScale(10) }} />
              <Text style={theme.bodyCopy}>{t('appReason2')}</Text>
            </View>
            <View style={theme.chevronTextContainer}>
              <ChevronRight style={{ marginRight: defaultScale(10) }} />
              <Text style={theme.bodyCopy}>{t('appReason3')}</Text>
            </View>
            <View style={theme.chevronTextContainer}>
              <ChevronRight style={{ marginRight: defaultScale(10) }} />
              <Text style={theme.bodyCopy}>{t('appReason4')}</Text>
            </View>
          </View>

          { actionButtons }
        </View>
      </View>
    );
  }
}

export default translate(['bookings'], { wait: true })(InstallApp);
